<template>
  <div class="view confirmation">
    <h6>{{ $t('registration.breadcrumb') }}</h6>
    <div class="confirmation">
      <h1>{{ $t('confirmation.title') }}</h1>
      <p>{{ $t('confirmation.copy') }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RegistrationConfirmation',
    components: {},
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      uid: {
        type: String,
        default: null,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
      };
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    filters: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    async mounted() {
      if (this.uid) {
        await this.$b.api.post('global/confirm', null, { uid: this.uid });
      }
    },
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
    },
  };
</script>

<style lang="scss">
  @import '~scss/variables';
  @import '~scss/mixins';

  .view.confirmation {
    padding: 68px 20px;
    h1 {
      position: relative;
      @include font-daimler-cac();
      font-size: 3.4rem;
      margin: 0 0 55px;
      padding: 0;
    }
    h3 {
      @include font-daimler-cac();
      font-size: 2.8rem;
      margin: 45px 0 0 0;
      padding: 0;
    }
    h6 {
      position: relative;
      @include font-daimler-cs(400);
      font-size: 1.6rem;
      margin: 0;
      padding: 0;

      &:after {
        content: '';
        position: relative;
        display: block;
        height: 2px;
        width: 46px;
        background-color: $color-white;
        margin-top: 25px;
        margin-bottom: 30px;
      }
    }

    div.confirmation {
      max-width: 622px;
      h1 {
        margin: 25px 0 25px;
      }
    }
  }
</style>
